import * as React from 'react'
import { useTranslation } from 'react-i18next'
import ButtonCustom from '@/components/ButtonCustom'
import { SizeButton } from '@/constants/sizeButton'
import { lightTheme } from '@/customTheme'

interface ShowMoreButtonProps {
  expanded: boolean
  onToggle: () => void
  variant?: 'text' | 'pill'
  active?: boolean
  moreLabel?: string
  lessLabel?: string
}

const NUDGE_STYLE = (
  <style>{`@keyframes arrow-nudge{0%{transform:translateY(0)}40%{transform:translateY(2px)}100%{transform:translateY(0)}}`}</style>
)

export function ShowMoreButton({
  expanded,
  onToggle,
  variant = 'text',
  active = true,
  moreLabel,
  lessLabel,
}: ShowMoreButtonProps) {
  const { t } = useTranslation()
  const more = moreLabel ?? t('Show more')
  const less = lessLabel ?? t('Show less')

  if (variant === 'pill') {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: '13px',
          opacity: active ? 1 : 0,
          transition: 'opacity 0.3s ease',
        }}
      >
        <ButtonCustom
          type={SizeButton.EXTRA_SMALL}
          kind="minimal"
          onClick={onToggle}
          style={{
            height: '24px',
            width: 'fit-content',
            ...lightTheme.typography.Small12medium,
            padding: '0 8px',
            borderRadius: '360px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '6px',
            background: lightTheme.colors.grayScale50,
            ':hover': {
              background: lightTheme.colors.grayScale100,
            },
          }}
        >
          <>
            {expanded ? less : more}
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                transform: expanded ? 'rotate(180deg)' : 'none',
                transition: 'transform 0.2s ease',
              }}
            >
              {NUDGE_STYLE}
              <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ animation: 'arrow-nudge 1.2s ease infinite' }}>
                <path d="M1 1L5 5L9 1" stroke={lightTheme.colors.blackGray} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
          </>
        </ButtonCustom>
      </div>
    )
  }

  return (
    <ButtonCustom
      type={SizeButton.EXTRA_SMALL}
      kind="minimal"
      onClick={onToggle}
      style={{
        width: 'fit-content',
        ...lightTheme.typography.Small12medium,
        padding: '0 8px',
      }}
    >
      <>{expanded ? less : more}</>
    </ButtonCustom>
  )
}
